import { executeSearchConstants } from '../constants'
import { executeSearchRequests } from '../../services'
import { handleErrorMessage } from '../../utils'

export const executeSearchActions = {}

executeSearchActions.GetByCodigoPostal = (data) => {
    return dispatch => {
        dispatch(request())
        executeSearchRequests.GetByCodigoPostal(data)
            .then(
                searchData => dispatch(success(searchData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: executeSearchConstants.SEARCH_REQUEST }
    }

    function success(searchData) {
        return { type: executeSearchConstants.SEARCH_SUCCESS, searchData }
    }

    function failure(error) {
        return { type: executeSearchConstants.SEARCH_FAILURE, error }
    }
}

executeSearchActions.GetByCustomCatalog = (data) => {
    return dispatch => {
        dispatch(request())
        executeSearchRequests.GetByCustomCatalog(data)
            .then(
                searchData => dispatch(success(searchData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: executeSearchConstants.SEARCH_AUTOCOMPLETE_REQUEST }
    }

    function success(searchData) {
        return { type: executeSearchConstants.SEARCH_AUTOCOMPLETE_SUCCESS, searchData }
    }

    function failure(error) {
        return { type: executeSearchConstants.SEARCH_AUTOCOMPLETE_FAILURE, error }
    }
}